module.exports = __webpack_public_path__ + "static/media/compass-logo-vector.6ee341bd.svg";